import { Icon } from '@iconify/react';

export const severityIcons = [ //
    {
        type: "critical",
        icon: "mdi:shield-alert",
        color: "text-accent"
    },
    {
        type: "high",
        icon: "material-symbols:speed",
        color: "text-yellow-600"
    },
    {
        type: "medium",
        icon: "mdi:message-alert",
        color: "text-primary"
    },
    {
        type: "low",
        icon: "mdi:server-remove",
        color: "text-violet-500"
    },
];

const AlertsCard = ({ alert, onClick }) => { // Modified: Removed 'value' prop as it wasn't used
    const iconConfig = severityIcons.find(item => item.type === alert.severity); //
    const icon = iconConfig ? iconConfig.icon : "mdi:alert-circle"; // Fallback icon

    return (
        <div className="alert-item gap-2 sm:gap-3 lg:gap-4" onClick={onClick}>
            {/* Main content area - full width layout */}
            <div className="flex flex-col gap-1.5 sm:gap-2 items-start min-w-0 flex-1">
                {/* Top row: Icon, Title, and Action Icon */}
                <div className="flex flex-row items-center gap-2 w-full">
                    <Icon icon={icon} className="text-xl sm:text-2xl text-secondary flex-shrink-0" />
                    <p className="text-sm sm:text-base lg:text-lg 2xl:text-lg font-medium truncate flex-1 min-w-0">
                        {alert.title}
                    </p>
                    <Icon icon="mdi:alert-box" className={`
                        text-xl sm:text-2xl lg:text-3xl flex-shrink-0
                        ${alert.actionRequired === true ? 'text-accent' : 'text-bgAccent'}
                    `} />
                </div>

                {/* Severity badge - positioned below on mobile/tablet, inline on 2xl+ */}
                <div className="flex flex-row items-center gap-2 w-full 2xl:hidden">
                    <div className={`
                        px-2 py-1 sm:px-3 sm:py-1.5 text-xs sm:text-sm bg-background shadow-neo-page-inner capitalize flex-shrink-0 rounded-md
                        ${alert.severity === 'critical' ? 'text-error' : `${iconConfig.color}`}
                    `}>
                        {alert.severity}
                    </div>
                </div>

                {/* Message - full width with proper truncation */}
                <div className="w-full min-w-0 overflow-hidden">
                    <p className="text-xs sm:text-sm text-font-secondary truncate w-full block leading-relaxed">
                        {alert.message}
                    </p>
                </div>

                {/* Bottom row: Status and Timestamp */}
                <div className="flex flex-row items-center justify-between w-full gap-2">
                    <div className={`
                        text-xs sm:text-sm capitalize flex-shrink-0 font-medium
                        ${alert.status === 'active' ? `${iconConfig.color} font-semibold` : 'text-font-secondary'}
                    `}>
                        {alert.status}
                    </div>
                    <p className="text-xs sm:text-sm text-font-secondary text-right leading-tight flex-shrink-0">
                        {new Date(alert.timestamp).toLocaleString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        })}
                    </p>
                </div>
            </div>

            {/* 2xl+ layout: Severity badge on the right */}
            <div className="hidden 2xl:flex flex-col gap-2 items-end justify-center h-full flex-shrink-0">
                <div className={`
                    px-3 py-1.5 text-sm bg-background shadow-neo-page-inner capitalize rounded-md
                    ${alert.severity === 'critical' ? 'text-error' : `${iconConfig.color}`}
                `}>
                    {alert.severity}
                </div>
            </div>
        </div>
    );
};

export default AlertsCard;